import * as tslib_1 from "tslib";
import { ElementRef, OnChanges, OnInit, PipeTransform, SimpleChanges } from '@angular/core';
import { OrderDetailsService } from './../../services/order-details/order-details.service';
var SubmitButtonTxt = /** @class */ (function () {
    function SubmitButtonTxt(_order) {
        this._order = _order;
    }
    /**
     * Generate button text
     */
    SubmitButtonTxt.prototype.getText = function (order, config) {
        var approvalRequired, reviewWindow, ineligibleMedsAdded, syncPlan = false;
        if (this._order.isSyncPlan(order)) {
            syncPlan = true;
        }
        else if (this._order.isWithinReviewWindow(order)) {
            reviewWindow = true;
            if (config.drugsInBox) {
                var ineligibleMeds = config.drugsInBox.filter(function (item) { return !item.eligibility; });
                if (ineligibleMeds.length > 0) {
                    ineligibleMedsAdded = true;
                }
            }
        }
        else if (this._order.isApprovalRequired(order)) {
            approvalRequired = true;
        }
        var txt = 'View order details';
        switch (config.buttonType) {
            case 'view':
                txt = reviewWindow
                    ? 'View or edit order'
                    : (approvalRequired
                        ? 'View and approve order'
                        : 'View order details');
                break;
            default:
                txt = reviewWindow
                    ? (config.showReconsentFlow
                        ? (ineligibleMedsAdded
                            ? 'Approve order'
                            : 'Update order')
                        : 'Update order')
                    : "Approve " + ((config.drugsRemoved || config.drugsAdded)
                        ? 'order with changes'
                        : 'order');
        }
        return txt;
    };
    return SubmitButtonTxt;
}());
export { SubmitButtonTxt };
/**
 * Generates text for button to approve or submit
 * order and reacts to changes in drugs removed or
 * added to order
 *
 * Can be used anywhere to view order details
 * @Usage
 * // to show text to view order
 *
 * <button appCvsSubmitOrderButton
 * [order]="Order" buttonType="view"></button>
 *
 * // to show text to approve order or submit order with changes
 *
 * <button appCvsSubmitOrderButton
 * [order]="Order"
 * [reviewWindow]="boolean"
 * [bust]="any"
 * [drugsAdded]="number"
 * [drugsRemoved]="number"></button>
 */
var SubmitOrderButtonDirective = /** @class */ (function (_super) {
    tslib_1.__extends(SubmitOrderButtonDirective, _super);
    function SubmitOrderButtonDirective(_elm, _orderDetails) {
        var _this = _super.call(this, _orderDetails) || this;
        _this._elm = _elm;
        _this._orderDetails = _orderDetails;
        return _this;
    }
    /**
     * Angular LifeCycle event
     */
    SubmitOrderButtonDirective.prototype.ngOnInit = function () {
        this.render();
    };
    /**
     * Angular LifeCycle event
     * React to order view changes
     */
    SubmitOrderButtonDirective.prototype.ngOnChanges = function (changes) {
        this.render();
    };
    /**
     * Render button text as per copy provided
     * and scenario given
     */
    SubmitOrderButtonDirective.prototype.render = function () {
        this._elm.nativeElement.innerText = this.getText(this.order, {
            buttonType: this.buttonType,
            drugsAdded: this.drugsAdded,
            drugsRemoved: this.drugsRemoved,
            drugsInBox: this.drugsInBox,
            showReconsentFlow: this.showReconsentFlow
        });
    };
    return SubmitOrderButtonDirective;
}(SubmitButtonTxt));
export { SubmitOrderButtonDirective };
/**
 * Generates text for button to approve or submit
 * order.
 *
 * Can  be used on view order details view or orders tab.
 * Use directive on edit order details
 *
 * @Usage
 * // to show text to view order
 * {{ order | appCvsSubmitOrderTxt:'view'}}
 * // to show text to approve order or submit order
 * {{ order | appCvsSubmitOrderTxt }}
 */
var SubmitOrderButtonPipe = /** @class */ (function (_super) {
    tslib_1.__extends(SubmitOrderButtonPipe, _super);
    function SubmitOrderButtonPipe(_orderDetails) {
        var _this = _super.call(this, _orderDetails) || this;
        _this._orderDetails = _orderDetails;
        return _this;
    }
    /**
     *
     */
    SubmitOrderButtonPipe.prototype.transform = function (order, args) {
        return this.getText(order, { buttonType: 'view' });
    };
    return SubmitOrderButtonPipe;
}(SubmitButtonTxt));
export { SubmitOrderButtonPipe };
